import React, { useEffect } from 'react'
import 'aos/dist/aos.css';
import AOS from 'aos';

const SHOW_TEAM = false;

const data = [
    {
        id: 1,
        imgUrl: '/avatar1.png',
        name: 'Fillipe Guerreiro',
        title: 'Founder & Director of Research Operations',
        fade:'fade-right'
    },
    {
        id: 2,
        imgUrl: '/avatar.png',
        name: 'Sania Khan',
        title: 'Co-Founder & Machine Learning Research Lead',
        fade:'fade-right'
    },
    {
        id: 17,
        imgUrl: '/avatar12.png',
        name: 'Usman Naveed',
        title: 'Quantitative Engineer',
        fade:'fade-right'
    },
    {
        id: 11,
        imgUrl: '/avatar13.png',
        name: 'Adeel Ali',
        title: 'Quantitative & Data Engineer',
        fade:'fade-left'
    },
    {
        id: 14,
        imgUrl: '/avatar11.png',
        name: 'Saqib Shams',
        title: 'Quantitative Systems Engineer',
        fade:'fade-right'
    },
    {
        id: 19,
        imgUrl: '/avatar4.png',
        name: 'Ashraf Nasib',
        title: 'Low Latency & Risk Systems Engineer',
        fade:'fade-left'
    },
    {
        id: 20,
        imgUrl: '/avatar13.png',
        name: 'Raja Habib Ahmed',
        title: 'Execution Systems Engineer',
        fade:'fade-left'
    },
    {
        id: 16,
        imgUrl: '/avatar3.png',
        name: 'Fatima Zohra',
        title: 'Infrastructure Engineer',
        fade:'fade-left'
    },
    {
        id: 10,
        imgUrl: '/avatar12.png',
        name: 'Touseef Husnain',
        title: 'Cybersecurity & Machine Learning Engineer',
        fade:'fade-right'
    },
    {
        id: 3,
        imgUrl: '/avatar2.png',
        name: 'Hasnat Khan',
        title: 'Compliance & Security Operations',
        fade:'fade-left'
    },
    {
        id: 4,
        imgUrl: '/avatar3.png',
        name: 'Hamna Khan',
        title: 'Head of Operations',
        fade:'fade-left'
    },
]

const About = () => {
    useEffect(() => {
        AOS.init({
            // Global settings here...
        });
    }, []);

    return (
        <>
            <div id='lab' className='lab-section section-grid mt-32 py-28 lg:py-32 xl:py-36 px-5 md:px-16 lg:px-20 flex flex-col justify-center items-center'>
                <div className='w-full max-w-screen-min-screen'>
                    <h1 data-aos="fade-up" data-aos-duration="1000" className='heading text-center'>Inside the Lab</h1>
                    <p data-aos="fade-up" data-aos-duration="1000" className='para text-center'>QLab operates as a quantitative research laboratory dedicated to building systematic trading infrastructure and financial intelligence systems. Our research integrates statistical modeling, machine learning, market microstructure analysis, and distributed computing to develop robust trading frameworks.</p>
                    <h1 data-aos="fade-up" data-aos-duration="1000" className='heading text-center mt-20'>Lab Mission</h1>
                    <p data-aos="fade-up" data-aos-duration="1000" className='para text-center'>Our mission is to design resilient algorithmic frameworks that adapt across market regimes. The research team works across quantitative finance, machine learning, and systems engineering to transform statistical insight into production-ready execution systems.</p>
                </div>
            </div>

            {SHOW_TEAM && (
            <div className='py-28 lg:py-32 xl:py-36 px-5 md:px-16 lg:px-20 flex flex-col justify-center items-center bg-white'>
                <div className='w-full max-w-screen-min-screen'>
                    <h1 data-aos="fade-up" data-aos-duration="1000" className='heading text-center'>Research Team</h1>
                    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>
                        {data.map((member, index) => (
                            <div key={member.id} data-aos={member.fade} data-aos-duration="1000" className='team-card h-80 cursor-pointer w-full relative bg-[#f1f1f1] rounded-xl flex flex-col p-4 pt-10 pb-6 justify-evenly items-center'>
                                <div className='fle flex-col justify-center items-center'>
                                    <img src={member.imgUrl} alt={member.name} className='team-avatar w-[161px] h-[161px] mx-auto' />
                                    <h3 className='team-member-name text-2xl metro text-center'>{member.name}</h3>
                                </div>
                                <h1 className='text-secondary-light text-base text-center leading-tight'>{member.title}</h1>
                                <p className='bg-[#26bfb5] p-1 w-10 h-10 rounded-full text-white font-semibold flex justify-center items-center absolute top-5 left-5'>{index + 1}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            )}
        </>
    )
}

export default About
